// extracted by mini-css-extract-plugin
module.exports = {"jussenButton":"Jussen_jussenButton__QHdB0"};